export default {
  type: 'condition.Logical',
  convert: (value, context) => {
    const {
      filterConverterFactory
    } = context;
    const conditions = value.conditions.map(c => filterConverterFactory.create(c, context)).filter(c => c != null);
    if (conditions.length === 0) {
      return null;
    }
    return {
      type: 'logical',
      conditions,
      operator: value.operator
    };
  }
};